import { getRequest, postRequest } from "../../../utils/apiHelper"; // Adjust path as needed
import {
  setFilesLoading,
  setFilesError,
  setFiles,
  setUploadLoading,
  setDeleteLoading,
  removeFilesByIds,
} from "./FilesSlice";

// Get attachments for an appointment
export const GetAttachmentsAPI = (appointmentId) => (dispatch) => {
  try {
    dispatch(setFilesLoading(true));
    dispatch(setFilesError(null));

    getRequest(
      `api/Attachment/GetAttachmentsById?formId=${appointmentId}&formTypeId=9`
    )
      .then((res) => {
        const documents = res?.data?.documents || [];
        const filteredFiles = documents
          .filter((doc) => !doc.isThumbnail)
          .map((doc) => ({
            id: doc.id,
            filename: doc.originalFileName,
            guidFileName: doc.guidFileName,
            base64Content: doc.base64Content,
            createdDate: doc.createdDate,
            fileType:
              doc.originalFileName.split(".").pop()?.toLowerCase() || "unknown",
          }));

        dispatch(setFiles(filteredFiles));
      })
      .catch((error) => {
        dispatch(
          setFilesError(
            error?.response?.data?.message || "Failed to fetch attachments"
          )
        );
      })
      .finally(() => {
        dispatch(setFilesLoading(false));
      });
  } catch (e) {
    dispatch(setFilesError("Failed to fetch attachments"));
    dispatch(setFilesLoading(false));
  }
};

// Upload files - FIXED: Updated endpoint to include 's' at the end
export const UploadFilesAPI = (payload, appointmentId) => (dispatch) => {
  try {
    dispatch(setUploadLoading(true));
    dispatch(setFilesError(null));
    postRequest("api/Attachment/UploadAttachments", payload)
      .then((res) => {
        dispatch(GetAttachmentsAPI(appointmentId));
      })
      .catch((error) => {
        dispatch(
          setFilesError(
            error?.response?.data?.message || "Failed to upload files"
          )
        );
      })
      .finally(() => {
        dispatch(setUploadLoading(false));
      });
  } catch (e) {
    dispatch(setFilesError("Failed to upload files"));
    dispatch(setUploadLoading(false));
  }
};

// Delete files
export const DeleteFileAPI = (fileIds) => (dispatch) => {
  try {
    dispatch(setDeleteLoading(true));
    dispatch(setFilesError(null));

    const idsArray = Array.isArray(fileIds) ? fileIds : [fileIds];

    postRequest("api/Attachment/DeleteAttachmentById", idsArray, {
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    })
      .then(() => {
        dispatch(removeFilesByIds(idsArray));
      })
      .catch((error) => {
        dispatch(
          setFilesError(
            error?.response?.data?.message || "Failed to delete files"
          )
        );
      })
      .finally(() => {
        dispatch(setDeleteLoading(false));
      });
  } catch (e) {
    dispatch(setFilesError("Failed to delete files"));
    dispatch(setDeleteLoading(false));
  }
};
